import { render } from "./modalePain.vue?vue&type=template&id=7c300c12"
import script from "./modalePain.vue?vue&type=script&lang=js"
export * from "./modalePain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__